export const environment = {
  production: false,
  testMode: true,
  apiUrl: 'https://sparguide-test.internal.sparbankensyd.se/api',
  commonServiceUrl: 'https://sparguide-test.internal.sparbankensyd.se/service',
  domain: 'sparguide-stage.internal.sparbankensyd.se'
}
